import React, { useState, useEffect, useRef, createContext } from "react";

const CEECampaignsContext = createContext();

export const CEECampaignsConsumer = CEECampaignsContext.Consumer;

const CEECampaignsProvider = (props) => {
  const [ceecampaign, setCeecampaign] = useState([]);

  return (
    <CEECampaignsContext.Provider
      value={{
        ceecampaign,
        setCeecampaign,
      }}
    >
      {props.children}
    </CEECampaignsContext.Provider>
  );
};

export default CEECampaignsContext;

export { CEECampaignsProvider, CEECampaignsContext };
